//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { decryptValue, showToastMessage } from "../../utils/app-utils";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@jack-henry/jh-ui/components/input/input.js";
import "@banno/jha-wc/src/icons/jha-icon-information";
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import Cookies from "js-cookie";

@customElement("file-pattern-view")
export class FilePatternView extends formElementMixin(LitElement) {
  constructor() {
    super();
  }
  static readonly styles = css`
    #patternDiv {
      display: flex;
      flex-direction: row;
      column-gap: var(--file-pattern-column-gap, 48px);
    }

    #triggerFileDiv,
    #dataFileDiv {
      display: flex;
      flex-direction: column;
    }

    #triggerFileInput,
    #dataFileInput {
      display: flex;
      flex-direction: row;
      column-gap: 30px;
      align-items: flex-start;
    }

    /* Ensure consistent icon alignment */
    #triggerFileInput > *,
    #dataFileInput > * {
      flex-shrink: 0;
    }

    #genInfoDiv {
      display: grid;
      grid-template-columns: auto auto auto;
      column-gap: 48px;
      padding-right: 15px;
      padding-left: 15px;
    }

    #errorText {
      color: red;
    }

    .filePatternTooltip {
      margin-top: 20px;
      position: absolute;
      border-radius: 4px;
      padding: 8px;
      width: 770px;
      height: 150px;
      background: black;
      color: white;
      box-sizing: border-box;
      z-index: 1061;
      display: none;
      font-size: 14px;
    }

    .filePatternTooltip ul {
      margin: 0;
      padding-left: 20px;
    }

    .filePatternTooltip li {
      margin-bottom: 4px;
    }

    @media (prefers-color-scheme: dark) {
      h2 {
        color: #a3d4ff;
      }
    }

    @media (prefers-color-scheme: light) {
      h2 {
        color: #06185f;
      }
    }

    h2 {
      grid-column: 1/4;
    }

    span {
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 10em;
      display: block;
      overflow: hidden;
    }

    .sticky {
      height: 60vh;
      position: fixed;
      top: 25%;
      left: 10%;
      width: 190vh;

      display: flex;
      flex-direction: column;
    }   

    .overflow {
      margin-top: 2% !important;
      overflow: auto;
      flex: 1 1 auto;
    }

    .overflow div {
      margin-bottom: 5px;
    }

    jh-input {
      width: 25vw;
      /* Match jha-form-select background color for consistency */
      --jh-color-container-primary-enabled: transparent;
    }

    /* Target the input part directly for background */
    jh-input::part(input) {
      background: transparent;
    }

    jha-form-row {
      align-items: baseline;
      column-gap: 20px;
    }

    .pattern-item {
      display: flex;
      justify-content: left;
    }

    .iconAddDivNeg4,
    .iconInfoDiv3,
    .iconAddDiv21,
    .iconInfoDiv27 {
      position: relative;
      height: 40px;
      display: flex;
      align-items: center;
      margin-top: 18px;
    }

    .iconInfo:hover + .filePatternTooltip {      
      display: block;
      position: absolute;
      top: 100%;
      z-index: 1061;
    }

    .filePatternTooltip.data-tooltip {
      left: 0;
    }

    .filePatternTooltip.trigger-tooltip {
      right: 0;
      left: auto;
    }
  `;

  @property() triggerFileName = "";
  @property() dataFileName = "";
  @property({ type: Array }) triggerFileList: string[] = [];
  @property({ type: Array }) dataFileList: string[] = [];
  @property({ type: Boolean }) editTriggerPattern = false;
  @property({ type: Boolean }) editDataPattern = false;
  @property({ type: Object })
  formData: {
    TriggerFilePattern: string[];
    DataFilePattern: string[];
    valid: boolean;
    isEdit: boolean;
    dataFileName?: string;
    triggerFileName?: string;
  } = {
      TriggerFilePattern: [],
      DataFilePattern: [],
      valid: false,
      isEdit: false,
    };

  @property({ type: String })
  toUpdate: string = "update";
  @property({ type: Array })
  dataArr = [];
  @property({ type: String })
  pageTitle = "Add Workflow";
  @property({ type: String })
  editDataFilePatternName = "";
  @property({ type: String })
  editTriggerFilePattern = "";
  @property({ type: String })
  editTriggerFilePatternName = "";
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole") || ""));

  async connectedCallback() {
    super.connectedCallback();
    this.triggerFileList = this.formData.TriggerFilePattern;
    this.dataFileList = this.formData.DataFilePattern;
    this.triggerFileName = this.formData.triggerFileName ?? "";
    this.dataFileName = this.formData.dataFileName ?? "";
    this.isEditable = this.formData.isEdit;
  }

  disconnectedCallback() {
    console.log(this.formData);
  }

  /**
   * Sync internal lists when formData property changes
   * This ensures data loaded after initial render is displayed
   */
  updated(changedProperties: Map<string, any>) {
    super.updated(changedProperties);

    if (changedProperties.has("formData")) {
      // Only update if the arrays are different (to avoid infinite loops)
      const newTrigger = this.formData.TriggerFilePattern || [];
      const newData = this.formData.DataFilePattern || [];

      // Check if trigger patterns changed
      if (JSON.stringify(this.triggerFileList) !== JSON.stringify(newTrigger)) {
        this.triggerFileList = [...newTrigger];
      }

      // Check if data patterns changed
      if (JSON.stringify(this.dataFileList) !== JSON.stringify(newData)) {
        this.dataFileList = [...newData];
      }

      this.isEditable = this.formData.isEdit;
    }
  }

  onFilePatternKeyDown(e: KeyboardEvent, add: () => void) {
    if (e.key !== "Enter" || e.isComposing || this.isReadOnlyUser) return;
    e.preventDefault();
    add();
  }

  onTriggerFileAdd() {
    const input = this.shadowRoot?.querySelector("jh-input[data-auto-id='workflowTriggerFilePatternInput']") as HTMLInputElement & {
      invalid: boolean;
    };
    if (!input) return;
    if (this.editTriggerPattern === false) {
      if (this.triggerFileName != "") {
        input.invalid = false;
        const isAlreadyPresent = this.triggerFileList.find((r) => r.toLowerCase() === this.triggerFileName.toLowerCase());
        if (!isAlreadyPresent) {
          this.triggerFileList.push(this.triggerFileName);
          this.triggerFileName = "";
          input.value = "";
        } else {
          showToastMessage("Pattern already exists.", "danger");
        }
        this.formData.TriggerFilePattern = this.triggerFileList;
        this.toUpdate = this.toUpdate == "" ? "update" : "";
        this.onTriggerFileNameInputChange();
      }
    } else if (this.editTriggerPattern === true) {
      if (this.triggerFileName != "") {
        const isAlreadyPresent = this.triggerFileList.find((r) => r.toLowerCase() === this.triggerFileName.toLowerCase());
        if (!isAlreadyPresent) {
          this.triggerFileList.push(this.triggerFileName);
          this.triggerFileName = "";
          input.value = "";
          this.editTriggerPattern = false;
        } else {
          showToastMessage("Pattern already exists.", "danger");
        }
      }
      this.formData.TriggerFilePattern = this.triggerFileList;
      this.toUpdate = this.toUpdate == "" ? "update" : "";
      this.onTriggerFileNameInputChange();
    }
  }

  private handleFileNameInputChange(
    inputSelector: string,
    fileNameProp: "triggerFileName" | "dataFileName",
    fileListProp: "triggerFileList" | "dataFileList"
  ) {
    const input = this.shadowRoot?.querySelector(inputSelector) as HTMLInputElement & { invalid: boolean };
    if (!input) return;

    this[fileNameProp] = input.value;
    this.formData.dataFileName = this.dataFileName;
    this.formData.triggerFileName = this.triggerFileName;
    const valueExists = this[fileListProp].some((r: string) => r.toLowerCase() === this[fileNameProp]?.toLowerCase());

    input.invalid = !!(this[fileNameProp] && !valueExists);

    // Only update icons associated with the current input row
    const inputRow = input.closest("#triggerFileInput, #dataFileInput");
    if (inputRow) {
      const iconInfoElements = inputRow.querySelectorAll("div[class*='iconInfoDiv']");
      iconInfoElements.forEach((infoIcon) => {
        infoIcon.classList.remove("iconInfoDiv3", "iconInfoDiv27");
        if (input.invalid) {
          infoIcon.classList.add("iconInfoDiv3");
        } else {
          infoIcon.classList.add("iconInfoDiv27");
        }
      });

      const iconPlusElements = inputRow.querySelectorAll("div[class*='iconAddDiv']");
      iconPlusElements.forEach((divPlusIcon) => {
        divPlusIcon.classList.remove("iconAddDivNeg4", "iconAddDiv21");
        if (input.invalid) {
          divPlusIcon.classList.add("iconAddDivNeg4");
        } else {
          divPlusIcon.classList.add("iconAddDiv21");
        }
      });
    }
  }

  onTriggerFileNameInputChange() {
    this.handleFileNameInputChange("jh-input[data-auto-id='workflowTriggerFilePatternInput']", "triggerFileName", "triggerFileList");
  }

  onDataFileNameInputChange() {
    this.handleFileNameInputChange("jh-input[data-auto-id='workflowDataFilePatternInput']", "dataFileName", "dataFileList");
  }

  onDataFileAdd() {
    const input = this.shadowRoot?.querySelector("jh-input[data-auto-id='workflowDataFilePatternInput']") as HTMLInputElement & {
      invalid: boolean;
    };

    if (!input) return;
    if (this.editDataPattern === false) {
      if (this.dataFileName != "") {
        input.invalid = false;
        const isAlreadyPresent = this.dataFileList.find((r) => r.toLowerCase() === this.dataFileName.toLowerCase());
        if (!isAlreadyPresent) {
          this.dataFileList.push(this.dataFileName);
          this.dataFileName = "";
          input.value = "";
        } else {
          showToastMessage("Pattern already exists.", "danger");
        }
        this.formData.DataFilePattern = this.dataFileList;
        this.toUpdate = this.toUpdate == "" ? "update" : "";
        this.onDataFileNameInputChange();
      }
    } else if (this.editDataPattern === true) {
      if (this.dataFileName != "") {
        const isAlreadyPresent = this.dataFileList.find((r) => r.toLowerCase() === this.dataFileName.toLowerCase());
        if (!isAlreadyPresent) {
          this.dataFileList.push(this.dataFileName);
          this.dataFileName = "";
          input.value = "";
          this.editDataPattern = false;
        } else {
          showToastMessage("Pattern already exists.", "danger");
        }
      }
      this.formData.DataFilePattern = this.dataFileList;
      this.toUpdate = this.toUpdate == "" ? "update" : "";
      this.onDataFileNameInputChange();
    }
  }

  onEditTriggerName(trgFileName: string): void {
    this.triggerFileName = trgFileName;
    this.editTriggerPattern = true;
    this.editTriggerFilePatternName = trgFileName;
    const deleteIndex = this.triggerFileList.indexOf(trgFileName);
    this.triggerFileList.splice(deleteIndex, 1);
    this.toUpdate = this.toUpdate == "" ? "update" : "";
  }

  onDeleteTriggerName(delIndex: string): void {
    const deleteIndex = this.triggerFileList.indexOf(delIndex);
    this.triggerFileList.splice(deleteIndex, 1);
    this.formData.TriggerFilePattern = this.triggerFileList;
    if (delIndex === this.triggerFileName) {
      this.triggerFileName = "";
    }
    this.toUpdate = this.toUpdate == "" ? "update" : "";
    this.onTriggerFileNameInputChange();
  }

  onEditDataName(dataName: string): void {
    this.dataFileName = dataName;
    this.editDataPattern = true;
    this.editDataFilePatternName = dataName;
    const deleteIndex = this.dataFileList.indexOf(dataName);
    this.dataFileList.splice(deleteIndex, 1);
    this.toUpdate = this.toUpdate == "" ? "update" : "";
  }

  onDeleteDataName(dataName: string): void {
    const deleteIndex = this.dataFileList.indexOf(dataName);
    this.dataFileList.splice(deleteIndex, 1);
    this.formData.DataFilePattern = this.dataFileList;
    if (dataName === this.dataFileName) {
      this.dataFileName = "";
    }
    this.toUpdate = this.toUpdate == "" ? "update" : "";
    this.onDataFileNameInputChange();
  }

  onDataFilePatternFocus(e: FocusEvent): void {
    (e.target as HTMLInputElement & { invalid: boolean }).invalid = this.dataFileList.length <= 0;
  }

  onTriggerFilePatternFocus(e: FocusEvent): void {
    (e.target as HTMLInputElement & { invalid: boolean }).invalid = this.triggerFileList.length <= 0;
  }

  onDataFileNameClear() {
    if (this.editDataPattern) {
      this.dataFileList.push(this.editDataFilePatternName);
      this.editDataPattern = false;
      this.dataFileName = "";
      this.editDataFilePatternName = "";
      this.toUpdate = this.toUpdate == "" ? "update" : "";
    } else {
      this.dataFileName = "";
    }
    this.onDataFileNameInputChange();
  }

  onTriggerFileClear() {
    if (this.editTriggerPattern) {
      this.triggerFileList.push(this.editTriggerFilePatternName);
      this.editTriggerPattern = false;
      this.triggerFileName = "";
      this.editTriggerFilePatternName = "";
      this.toUpdate = this.toUpdate == "" ? "update" : "";
    } else {
      this.triggerFileName = "";
    }
    this.onTriggerFileNameInputChange();
  }

  private dispatchFilePatternChange() {
    this.dispatchEvent(
      new CustomEvent("onFilePatternChange", {
        detail: this.formData,
        bubbles: true,
        composed: true,
      })
    );
  }

  renderFilePatternTooltip(dataInput: string) {
    const tooltipClass = dataInput === "data" ? "data-tooltip" : "trigger-tooltip";
    return html`
      <span class="filePatternTooltip ${tooltipClass}">
        <ul>
          <li>This field is case insensitive.</li>
          <li>Patterns entered in lower case and uppercase are treated the same.</li>
          <li>For Wildcard File Patterns, make sure to include *. Examples: *.zip, *trigger*.txt, TransferFile.</li>
          <li>For Absolute File Patterns with extension, make sure to enter the exact file name. Examples: triggerfile.txt
          </li>
          <li>For Absolute File Patterns without extension, make sure to include $ at the end. Examples: SLOT199$, slot081$
          </li>
        </ul>
      </span>
    `;
  }

  renderDataFilePatternSection() {
    return html`
      <div id="dataFileDiv">
        <div id="dataFileInput">
          <jh-tooltip position="bottom-start"
            label="Enter Data File Pattern. For multiple sources, include parent folder name.">
            <jh-input data-auto-id="workflowDataFilePatternInput" label="Workflow Data File Pattern *"
              placeholder="eg: *.txt, *.zip, datafile.txt" type="text" outline show-clear-button
              error-text="Click the '+' icon to add." ?disabled=${this.isReadOnlyUser}
              @input=${this.onDataFileNameInputChange}
              @keydown=${(e: KeyboardEvent) => this.onFilePatternKeyDown(e, () => this.onDataFileAdd())}
              @jh-clear=${this.onDataFileNameClear} maxlength="256"
              .value=${this.dataFileName}>
            </jh-input>
          </jh-tooltip>
      
          <!-- Info icon cell -->
          <div class="iconInfoDiv27">
            <jha-icon-information class="iconInfo"></jha-icon-information>
            ${this.renderFilePatternTooltip("data")}
          </div>
      
          <!-- Add button / plus icon cell -->
          <jh-tooltip position="bottom-start" label="Click '+' to add Data File Pattern." class="iconAddDiv21">
            <jha-button data-auto-id="addDataBtn" icon sync ?disabled=${this.isReadOnlyUser} type="button"
              @click=${this.onDataFileAdd}>
              <jha-icon-plus></jha-icon-plus>
            </jha-button>
          </jh-tooltip>
        </div>
        <div>
          <ul>
            ${this.dataFileList?.map((dataFileName) =>
      this.renderPatternItem(
        dataFileName,
        this.editDataPattern,
        () => this.onEditDataName(dataFileName),
        () => this.onDeleteDataName(dataFileName),
        "Edit Data File Pattern",
        "Delete Data File Pattern",
        "editDataBtn",
        "deleteDataBtn"
      )
    )}
          </ul>
        </div>
      </div>
    `;
  }

  renderTriggerFilePatternSection() {
    return html`
      <div id="triggerFileDiv">
        <div id="triggerFileInput">
          <jh-tooltip position="bottom-start"
            label="Enter Trigger File Pattern. For multiple sources, include parent folder name.">
            <jh-input data-auto-id="workflowTriggerFilePatternInput" label="Workflow Trigger File Pattern *"
              placeholder="eg: *.txt, *.zip, triggerfile.txt" type="text" outline show-clear-button
              error-text="Click the '+' icon to add." ?disabled=${this.isReadOnlyUser}
              @input=${this.onTriggerFileNameInputChange}
              @keydown=${(e: KeyboardEvent) => this.onFilePatternKeyDown(e, () => this.onTriggerFileAdd())}
              @jh-clear=${this.onTriggerFileClear} maxlength="256"
              .value=${this.triggerFileName}>
            </jh-input>
          </jh-tooltip>
      
          <div class="iconInfoDiv27">
            <jha-icon-information class="iconInfo"></jha-icon-information>
            ${this.renderFilePatternTooltip("trigger")}
          </div>
      
          <jh-tooltip position="bottom-start" label="Click '+' to add Trigger File Pattern" class="iconAddDiv21">
            <jha-button data-auto-id="addTriggerBtn" sync icon ?disabled=${this.isReadOnlyUser} type="button"
              @click=${this.onTriggerFileAdd}>
              <jha-icon-plus></jha-icon-plus>
            </jha-button>
          </jh-tooltip>
        </div>
        <div>
          <ul>
            ${this.triggerFileList?.map((trgName) =>
      this.renderPatternItem(
        trgName,
        this.editTriggerPattern,
        () => this.onEditTriggerName(trgName),
        () => this.onDeleteTriggerName(trgName),
        "Edit Trigger File Pattern",
        "Delete Trigger File Pattern",
        "editTriggerBtn",
        "deleteTriggerBtn"
      )
    )}
          </ul>
        </div>
      </div>
    `;
  }

  renderPatternItem(
    item: string,
    isEditDisabled: boolean,
    onEdit: () => void,
    onDelete: () => void,
    editTooltip: string,
    deleteTooltip: string,
    editDataAutoId: string,
    deleteDataAutoId: string
  ) {
    return html`
      <div style="display: flex; justify-content: left;">
        <li style="font-size:large;">
          <span title=${item}>${item} </span>
        </li>
        <jha-tooltip bottom text=${editTooltip}>
          <jha-button data-auto-id=${editDataAutoId} icon sync ?disabled=${this.isReadOnlyUser || isEditDisabled}
            type="button" @click=${onEdit}>
            <jha-icon-edit></jha-icon-edit>
          </jha-button>
        </jha-tooltip>
        <jha-tooltip bottom text=${deleteTooltip}>
          <jha-button data-auto-id=${deleteDataAutoId} icon sync ?disabled=${this.isReadOnlyUser} type="button"
            @click=${onDelete}>
            <jha-icon-delete></jha-icon-delete>
          </jha-button>
        </jha-tooltip>
      </div>
    `;
  }

  render() {
    this.dispatchFilePatternChange();
    return html`
      <div style="padding-left: 15px; padding-right: 15px; padding-top: 20px;">
        <form @focusout=${() => {
        if (this.formDirty) this.formData.valid = this.formValid;
      }}>
          <h2>File Patterns</h2>
          <div id="patternDiv">${this.renderDataFilePatternSection()} ${this.renderTriggerFilePatternSection()}</div>
        </form>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "file-pattern-view": FilePatternView;
  }
}
